import React from 'react';

import {SkeletonItem} from 'src/components/skeleton';

import {FormSection} from '@pb/kit-component-form-section';
import {Group, Item} from '@pb/kit-component-group';


export const UserInformationSkeleton = () => (
    <FormSection
        headline="User Information"
        info={() => (
            <Item grow={1}>
                <Group>
                    <SkeletonItem width={170} height={28}/>
                    <SkeletonItem width={76} height={28}/>
                </Group>
            </Item>
        )}>
        <Group justify="space-between" alignItems="start">
            <Group justify="start" direction="v" gap="s">
                <Group>
                    <SkeletonItem width={70} height={17}/>
                    <SkeletonItem width={140} height={17}/>
                </Group>
                <Group>
                    <SkeletonItem width={70} height={17}/>
                    <SkeletonItem width={140} height={17}/>
                </Group>
                <Group>
                    <SkeletonItem width={70} height={17}/>
                    <SkeletonItem width={140} height={17}/>
                </Group>
                <Group>
                    <SkeletonItem width={70} height={17}/>
                    <SkeletonItem width={140} height={17}/>
                </Group>
            </Group>
            <Group justify="start" direction="v" gap="s">
                <Group>
                    <SkeletonItem width={90} height={17}/>
                    <SkeletonItem width={120} height={17}/>
                </Group>
                <Group>
                    <SkeletonItem width={90} height={17}/>
                    <SkeletonItem width={120} height={17}/>
                </Group>
                <Group>
                    <SkeletonItem width={90} height={17}/>
                    <SkeletonItem width={120} height={17}/>
                </Group>
                <Group>
                    <SkeletonItem width={90} height={17}/>
                    <SkeletonItem width={120} height={17}/>
                </Group>
                <Group>
                    <SkeletonItem width={70} height={17}/>
                    <SkeletonItem width={140} height={17}/>
                </Group>
            </Group>
        </Group>
    </FormSection>
);
